import { BlogMetadataRecord } from 'api/clients/BlogMetadataRecordsClient'

/**
 * Helper function to get alt text for the current featured image during initialization
 * Matches the same fallback logic as featuredImageUrl initialization:
 * 1. If current_featured_image is set, use its alt_text
 * 2. If no current_featured_image but there are images, use first image's alt_text
 * 3. Otherwise, empty string
 */
export const getInitialAltText = (initialData: BlogMetadataRecord): string => {
  const selectedImages = initialData?.featured_media?.featured_selected_images || []

  // First, try to get alt text for the current featured image
  const currentImageUrl = initialData?.featured_media?.current_featured_image
  if (currentImageUrl) {
    const currentImageObj = selectedImages.find((img) => img.url === currentImageUrl)
    return currentImageObj?.alt_text || ''
  }

  // If no current featured image, fall back to first image's alt text (matches featuredImageUrl logic)
  if (selectedImages.length > 0) {
    return selectedImages[0].alt_text || ''
  }

  // No images at all
  return ''
}
